// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2X7Pp","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__Yl3Pm"};